import { gql } from '@apollo/client'

const CREATE_MANY_FUNDER_ORG_USERS = gql`
  mutation createManyFunderUsers(
    $funderUsersInfo: [BulkFunderUserInput!]!
    $funderOrgId: Int!
    $inviterUserId: Int!
  ) {
    createManyFunderUsers(
      funderUsersInfo: $funderUsersInfo
      funderOrgId: $funderOrgId
      inviterUserId: $inviterUserId
    ) {
      email
    }
  }
`

export default CREATE_MANY_FUNDER_ORG_USERS
